/**
 * Apply interceptors to `fetch` and create a custom request function.
 * @param fetch - Yours environment Fetch function.
 * @param interceptors - Interceptors as a kind of protocol to handle requests.
 */
const createRequest = (fetch, { onError = (reason) => Promise.reject(reason), onRequest = (options) => options, onRequestError = onError, onResponse = (response) => Promise.resolve(response), onResponseError = onError } = {}) => {
    return function () {
        // `arguments` instead of `...args` to improve performance and reduce
        // bundle size. TS/Babel/Bublé don't need to transpile it.
        const params = arguments;
        try {
            // `.apply(null, args)` instead of `(...args)` for same reason as above.
            const options = onRequest.apply(null, params);
            return (fetch(options.url, options)
                .then(onResponse)
                .catch(onResponseError));
        }
        catch (reason) {
            return onRequestError(reason);
        }
    };
};
export default createRequest;
